import * as React from 'react';
import { Create } from 'react-admin';
import { UserForm } from './commons';
import { transformRecord } from './utils';

const UserCreate = () => (
    <Create transform={transformRecord} redirect="list">
        <UserForm passwordRequired/>
    </Create >
);

export default UserCreate;
